import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { PaymentMethod } from "~/providers/payment-method-provider";

interface PaymentMethodStoreState {
  paymentMethodFormOpen: boolean;
  selectedPaymentMethod?: PaymentMethod;
  setSelectedPaymentMethod: (selected?: PaymentMethod) => void;
  setPaymentMethodFormOpen: (open: boolean) => void;
}

export const usePaymentMethodStore = create<PaymentMethodStoreState>()(
  devtools((set) => ({
    paymentMethodFormOpen: false,
    setSelectedPaymentMethod(selected) {
      set(() => ({ selectedPaymentMethod: selected }));
    },
    setPaymentMethodFormOpen(open) {
      set(() => ({ paymentMethodFormOpen: open }));
    },
  })),
);
